import * as React from 'react'
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';

import { RRule } from 'rrule'

const NextOccurenceField = (props) => {
    const { source } = props;
    const record = useRecordContext(props);

    const rule = RRule.fromString(record[source]);
    const dates = rule.all(function (date, i){return i < 1});
    console.log(dates);
    let value = "None";
    if (dates.length > 0) {
        value = dates[0].toString();
    }

    return (<Typography
        component="span"
        variant="body2"
    >
        {value}
    </Typography>
    );
};

NextOccurenceField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default NextOccurenceField;